import React from 'react';
import { ExecutiveDashboardView } from '../../utils/reportFiltersComparison';

export interface ExecutiveDashboardMainTabsProps {
  activeTab: ExecutiveDashboardView;
  onTabChange: (tab: ExecutiveDashboardView) => void;
  breakdownContent: React.ReactNode;
  moversContent: React.ReactNode;
}

const tabButtonBase: React.CSSProperties = {
  padding: '0.65rem 1.15rem',
  marginBottom: '-1px',
  border: 'none',
  borderBottom: '3px solid transparent',
  background: 'transparent',
  cursor: 'pointer',
  fontSize: '0.95rem',
  fontWeight: 600,
  color: 'var(--report-text-muted)',
};

/**
 * Executive dashboard: **Breakdown** (comparison-style grouped tables) vs **Movers** (decliners / performers widgets).
 */
const ExecutiveDashboardMainTabs: React.FC<ExecutiveDashboardMainTabsProps> = ({
  activeTab,
  onTabChange,
  breakdownContent,
  moversContent,
}) => (
  <div style={{ marginTop: '0.25rem' }}>
    <div
      role="tablist"
      aria-label="Executive dashboard sections"
      style={{
        display: 'flex',
        gap: '0.5rem',
        marginBottom: '1.25rem',
        borderBottom: '1px solid var(--report-border)',
      }}
    >
      <button
        type="button"
        role="tab"
        id="tab-breakdown"
        aria-selected={activeTab === 'breakdown'}
        aria-controls="panel-breakdown"
        onClick={() => onTabChange('breakdown')}
        style={{
          ...tabButtonBase,
          ...(activeTab === 'breakdown'
            ? { color: 'var(--report-accent)', borderBottomColor: 'var(--report-accent)' }
            : {}),
        }}
      >
        Breakdown
      </button>
      <button
        type="button"
        role="tab"
        id="tab-movers"
        aria-selected={activeTab === 'movers'}
        aria-controls="panel-movers"
        onClick={() => onTabChange('movers')}
        style={{
          ...tabButtonBase,
          ...(activeTab === 'movers'
            ? { color: 'var(--report-accent)', borderBottomColor: 'var(--report-accent)' }
            : {}),
        }}
      >
        Movers
      </button>
    </div>
    {activeTab === 'breakdown' ? (
      <div role="tabpanel" id="panel-breakdown" aria-labelledby="tab-breakdown">
        {breakdownContent}
      </div>
    ) : (
      <div role="tabpanel" id="panel-movers" aria-labelledby="tab-movers">
        {moversContent}
      </div>
    )}
  </div>
);

export default ExecutiveDashboardMainTabs;
